import { render, staticRenderFns } from "./ManageValidationReasonEdit.vue?vue&type=template&id=bf787dd6"
import script from "./ManageValidationReasonEdit.vue?vue&type=script&lang=js"
export * from "./ManageValidationReasonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports